import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  faAngleDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalendar,
  faChild,
  faClock,
  faClose,
  faEnvelope, faEnvelopeOpen,
  faFaceSmile,
  faLocationDot,
  faLongArrowRight,
  faMinus,
  faPersonWalkingLuggage,
  faPlane,
  faPlaneArrival,
  faPlaneDeparture,
  faPlus,
  faRightLeft,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { merge, Observable, of } from 'rxjs';
import { ActiveModifySearch, BookingBasicProperties, ChildAgeProps, FlightSearchAirlineCodes, FlightSearchAirports, FlightSearchBaseData, FlightSearchDestinationProperties, FlightSearchHistory, FlightSearchProperties, FlightSearchPropModify, FlightSearchRights, InfantAgeProps, ModifyFlightAirAiternary, OtherFlightDetailsNames } from '../Models/FlightSearchProperties';
import { FaretypeFilters, FilterFlightResultBinding, FlightSchedulesNew, FlightSearchNewResponseProperties, StopFlightFilters, flightsectorIndex, MulticityResponseFlightsNew, TimeListFilter, FilterByAirlineProperties, AirSegmentsDetailsNew, BySectorBrands, BrandsNew, RBDBaggageSelection, RBDPaneltyCharges, RBDChargeSelection } from '../Models/flight-results-response-properties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { FlightResultAdditionalProcess } from '../flightResultsNew/flight-result-filters-process';
import { GetFlightResultsService } from '../Services/get-flight-results.service';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { ChangeRBDParamsGalileo, SelectRBD, modifyFlights } from '../Models/FlightSearchResponseProperties';
import { CriteriaHideShowProperties } from '../Models/ModifyAirItienary';
import { BookingInfoProperties, ModifyDataCarry } from '../Models/BookingPassengerTicketIssuanceProperties';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

//declare var $;
@Component({
  selector: 'app-modify-air-itinerary',
  templateUrl: './modify-air-itinerary.component.html',
  styleUrls: ['./modify-air-itinerary.component.css'],
  providers: [BsDatepickerConfig, BsDaterangepickerConfig]
})


export class ModifyAirItineraryComponent {
  @ViewChild('addTraveler', { static: true }) addTravelerModal!: ElementRef;
  flightresultadditionalProcessts = new FlightResultAdditionalProcess();
  faplane = faPlane;
  faArrowRightToCity = faLongArrowRight;
  faLocationDot = faLocationDot;
  faPlaneDeparture = faPlaneDeparture;
  faPlaneArrival = faPlaneArrival;
  faMinus = faMinus;
  faplus = faPlus;
  faRightLeft = faRightLeft;
  faPlus = faPlus;
  Close = faClose;
  PersonIcon = faUser;
  faChild = faChild;
  FaceSmile = faFaceSmile;
  adultDropdowndiv: boolean = false;
  faArrowUp = faArrowUp;
  faEnvelope = faEnvelope;
  faEnvelopeOpen = faEnvelopeOpen;
  faArrowDown = faArrowDown;
  faAngleDown = faAngleDown;
  faCalendar = faCalendar;
  PersonWalking = faPersonWalkingLuggage;
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  faClock = faClock;
  screenHeight: number;
  screenWidth: number;
  dropdownadult = false;
  dropdowneconomy = false;
  dropdownfaretype = false;
  loaderSending: boolean = false;
  childAge: boolean = false;
  InfantAge: boolean = false;
  dateCalenderShow: number = 3;
  rangeDates: Date[] | undefined;
  childList: Number[] = [];
  infantList: Number[] = [];
  filteredAirportsOW: string[] = [];
  // childAgeListOfR: ChildAgeProps[] = [];
  // infantAgeListOfR: InfantAgeProps[] = [];
  airportList: FlightSearchAirports[] = [];
  childAgeItemR: number = 0;
  childAgeValueR: number;
  childAgeListOf: ChildAgeProps[] = [];
  infantAgeListOf: InfantAgeProps[] = [];
  childAgeItem: number = 0;
  priceOfBrand: number = 0;
  childAgeValue: number;
  finalcountofpassengers: number = 1;
  infantAgeValue: string;
  currentIndex: number = 0;
  infantAgeValueR: string;
  Adulttravlers: boolean = true;
  IMPORTRights: boolean = false;
  modalfzconfirm: boolean = false;
  AllTravelers: boolean = false;
  modifymultishow: boolean = false;
  modifyorignalshow: boolean = true;
  minDate: Date;
  maxDate: Date;
  haveRights: boolean = false;
  allBaseData$ = new FlightSearchBaseData();
  airlineList$: Observable<FlightSearchAirlineCodes[]>;
  childAgeObj = new ChildAgeProps();
  dataSource: any;
  infantAgeObj = new InfantAgeProps();
  airLineData: FlightSearchAirlineCodes[] = [];
  modifysearchObj = new FlightSearchProperties();
  onewaymodifysearchObj = new FlightSearchProperties();
  roundmodifysearchObj = new FlightSearchProperties();
  multicitymodifysearchObj = new FlightSearchProperties();
  sentToBacksearchObj = new FlightSearchProperties();
  AgencyData = new AgencyMasterProperties();
  ingredient: boolean = false;
  dataFormSubmitoneway: boolean = false;
  flightDetailsopen: boolean[] = [false];
  brandDetailsopen: boolean[] = [false];
  brandCombinationDetailsopen: boolean[] = [false];
  farerulesopen: boolean[] = [false];
  emailpopupopen: boolean = false;
  sliderAirlineShow: boolean = true
  emailpopupValidateCheck: boolean = false;
  emailpopupFlightIndex: number = 0;
  baggagedetailsopen: boolean[] = [false];
  changebookingdetailsopen: boolean[] = [false];
  searchObj = new FlightSearchProperties();
  selectedDiv: number | null = null;
  emailObj = new EmailItineraryProperties();
  flighResultObj = new FlightSearchNewResponseProperties();
  activesearch: number = 0;
  initialsearch: number = 0;
  flightsBindList: FlightSchedulesNew[] = [];
  displayedFlights: FlightSchedulesNew[] = [];
  batchSize: number = 100;
  startIndex: number = 0;
  popoverArray: boolean[] = [];
  filtersBinding = new FilterFlightResultBinding();
  currencyForShow: string = "";
  oneWayResults: boolean = false;
  roundTripResults: boolean = false;
  multicityResults: boolean = false;
  checkpanelcollapsed: boolean = false;
  //mobile declareation start here 
  mobilepopupmodifysearch: boolean = false;
  grossPrice: string;
  minValueSliderFilter: number = 0;
  maxValueSliderFilter: number = 0;
  tooltip: any;
  flightsectorIndexlist: flightsectorIndex[] = [];
  flightrequestCounter: number;
  flightresponseCounter: number;
  flightshortCountSkelton: number[] = [];
  flightsloading: boolean;
  flightsBeforeLoad: boolean;
  progressValue: number;
  totalDirectFlights: number = 0;
  totalOneStopFlights: number = 0;
  totalTwoPlusStopFlights: number = 0;
  totalRefundableFlights: number = 0;
  totalNonRefundableFlights: number = 0;
  //group ticket
  flightSearchRightsObj = new FlightSearchRights();
  noflightavailable: boolean = false;
  multibranderrormessage: boolean = false;
  previousmarkup: number = 0;
  rbdflightData = new FlightSearchNewResponseProperties();
  grossTotal: number = 0;
  rbdBaggage: RBDBaggageSelection[] = [];
  penaltyCharge: RBDPaneltyCharges[] = [];
  rbdCharg: RBDChargeSelection[] = [];
  criteriaHideMethodObj = new CriteriaHideShowProperties();
  bookingObj = new BookingInfoProperties();
  modifyFlights = new modifyFlights();
  partial: boolean = false;
  partialMessage: string = "";
  fzTransactionIdentifier: string;
  retrivePnrResp: string;
  ModifyData: any;
  OrigionalData: ModifyDataCarry;
  modDep: boolean = false;
  modRet: boolean = false;
  constructor(private confirmationService: ConfirmationService, private emailService: EmailItineraryService, private router: Router, private flightService: FlightSearchService, private getFlightResultService: GetFlightResultsService, private messageService: MessageService, private modalService: NgbModal) {
  }
  @ViewChild('slider', { static: false }) slider: ElementRef<HTMLElement>;
  @ViewChild('slide', { static: false }) slide: ElementRef<HTMLElement>;
  ngOnInit() {
    try {

      // this.flightsBeforeLoad = true;
      this.currencyForShow = localStorage.getItem("AgencyCurrency");
      const flightSearchData = localStorage.getItem('flightmodifysearch');
      const bookingData = localStorage.getItem('flightmodifyBookingInfo');


      if (!flightSearchData) {
        this.router.navigateByUrl("/ticket-Issuance");
        return;
      }

      this.searchObj = JSON.parse(flightSearchData);
      this.bookingObj = JSON.parse(bookingData);
      this.CriteriaHideShowFunction();
      this.initialsearch = this.searchObj.journeyType;
      this.finalcountofpassengers = this.searchObj.adult + this.searchObj.child + this.searchObj.infant;
      if (this.searchObj.child > 0 || this.searchObj.infant > 0) {
        this.AllTravelers = true;
        this.Adulttravlers = false;
      }
      this.batchSize = 100;
      this.startIndex = 0;
      this.flightrequestCounter = 0;
      this.flightresponseCounter = 0;
      this.flighResultObj = new FlightSearchNewResponseProperties();
      this.flighResultObj.flights = [];
      this.flightsBindList = [];
      this.displayedFlights = [];
      this.popoverArray = [];
      this.filtersBinding.airlinesList = [];
      this.filtersBinding.fareType = new FaretypeFilters();
      this.filtersBinding.timeList = new TimeListFilter();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
      this.sliderAirlineShow = false;
      this.flightsBeforeLoad = false;
      
      this.tooltip = {
        enabled: true,
        showMode: 'always',
        position: 'top',
      };
    }
    catch (e) {

    }

    this.showtoggleflighttypeDiv(this.searchObj.journeyType);
    this.GetSearchBaseData();
    this.DateMinMaxMulti();
    this.searchReadyToBack(true);
    this.GetAgencyMasterForPrint();
  }
  ngOnDestroy() {
    localStorage.removeItem('flightmodifysearch');
     localStorage.removeItem('flightmodifyBookingInfo');
  }
  /*
  ------------------------------------------------------------------------------------------------------------------------------------------
  -----------------------------------------------------Modify Search Work Start Here--------------------------------------------------------
  ------------------------------------------------------------------------------------------------------------------------------------------
  */
  CriteriaHideShowFunction() {
    if (this.bookingObj.providerCode == "PA" || this.bookingObj.providerCode == "EK") {
      this.criteriaHideMethodObj.dateChangeFields = true;
      this.criteriaHideMethodObj.searchFields = true;
      this.criteriaHideMethodObj.tripTypeToggle = true;
      this.criteriaHideMethodObj.filtersModifySearch = false;
      this.criteriaHideMethodObj.passengerAdd = false;
    }
    else if (this.bookingObj.providerCode == "AI") {
      this.criteriaHideMethodObj.dateChangeFields = true;
      this.criteriaHideMethodObj.searchFields = true;
      this.criteriaHideMethodObj.tripTypeToggle = false;
      this.criteriaHideMethodObj.filtersModifySearch = false;
      this.criteriaHideMethodObj.passengerAdd = false;
    }
    else if (this.bookingObj.providerCode == "FZ") {
      this.criteriaHideMethodObj.dateChangeFields = false;
      this.criteriaHideMethodObj.searchFields = true;
      this.criteriaHideMethodObj.tripTypeToggle = true;
      this.criteriaHideMethodObj.filtersModifySearch = false;
      this.criteriaHideMethodObj.passengerAdd = true;
    }
    else if (this.bookingObj.providerCode == "SG") {
      this.criteriaHideMethodObj.dateChangeFields = true;
      this.criteriaHideMethodObj.searchFields = true;
      this.criteriaHideMethodObj.tripTypeToggle = false;
      this.criteriaHideMethodObj.filtersModifySearch = false;
      this.criteriaHideMethodObj.passengerAdd = false;
    }

  }
  cabinClassList = [
    { cabinItem: "Economy" },
    { cabinItem: "Business" },
    { cabinItem: "Premium Economy" },
    { cabinItem: "First" },
    /*{ cabinItem: "PremiumEconomy" },*/
  ];
  childAgeList = [
    { childAgeItem: 2 },
    { childAgeItem: 3 },
    { childAgeItem: 4 },
    { childAgeItem: 5 },
    { childAgeItem: 6 },
    { childAgeItem: 7 },
    { childAgeItem: 8 },
    { childAgeItem: 9 },
    { childAgeItem: 10 },
    { childAgeItem: 11 }
  ];
  infantAgeList = [
    { infantAgeItem: "less than 1" },
    { infantAgeItem: "1" }
  ];
  fareTypeList = [
    { fareItem: "Low Fares" },
    { fareItem: "Refundable" },
    { fareItem: "Non-Refundable" },
  ];
  Dropdownadults() {
    if (this.adultDropdowndiv) {
      this.adultDropdowndiv = false;
    } else {
      this.adultDropdowndiv = true;
    }
    this.dropdownfaretype = false;
    this.dropdowneconomy = false;
  }
  GetSearchBaseData() {
    try {
      this.flightService.CheckFlightSearchScreenRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data1) => {
        this.haveRights = data1;
        this.flightService.GetFlightBaseData().subscribe((data) => {
          this.allBaseData$ = data;
          /* this.originalAirlines = this.allBaseData$.airlines;*/
          this.airlineList$ = of(this.allBaseData$.airlines);


          this.airLineData = this.allBaseData$.airlines;
          this.airportList = this.allBaseData$.airports;


          this.dataSource = new DataSource({
            store: new ArrayStore({
              data: this.airportList,
              key: "airportName"
            }),
            group: "cityCountry",

          });
          this.flightService.CheckImportRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
            this.IMPORTRights = data2;
          })
          this.dataSource.load();

          // this.tbOnewayFromAuto.instance.focus();
          //}
        })
      })
    }
    catch (e) {

    }
  }
  filterAirportsOW(event: any) {
    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }
  decrementCount() {
    if (this.modifysearchObj.adult > 0) {


      this.modifysearchObj.infant = 0;
      this.infantAgeListOf.length = 0;


      this.modifysearchObj.adult--;
      if (this.modifysearchObj.adult < 1) {
        let one = document.getElementById("minusAdult") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      if (this.modifysearchObj.adult <= 9) {
        let one = document.getElementById("plusAdult") as HTMLButtonElement;
        one.style.color = "var(--first-color-second)";
      }

    }
  }
  incrementCount() {


    this.infantAgeListOf.length = 0;
    if (this.modifysearchObj.adult < 9) {

      this.modifysearchObj.adult++;
      if (this.modifysearchObj.adult > 0) {
        let one = document.getElementById("minusAdult") as HTMLButtonElement;
        one.style.color = "var(--first-color-second)";


      }

      if (this.modifysearchObj.adult == 9) {
        let one = document.getElementById("plusAdult") as HTMLButtonElement;
        one.style.color = "#00000063";
      }

      if (this.modifysearchObj.adult + this.modifysearchObj.child > 9) {
        this.childAgeListOf.length = 0;
      }
      if (this.modifysearchObj.adult + this.modifysearchObj.child == 9) {

      }

      this.ChangeOnewayAdult(this.modifysearchObj.adult);
    }


  }
  ChangeOnewayAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.modifysearchObj.child) > 9) {
          this.modifysearchObj.child = this.childList.length;
          this.ChangeChildAge(this.modifysearchObj.child);
        };
        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }


      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }

      if (value > 0) {
        this.infantList = [];
        this.modifysearchObj.infant = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
      }
      else if (value == null || value == undefined) {
        this.modifysearchObj.infant = 0;
        this.infantList = [0];
        this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
      }

      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }
  incrementcountChild() {
    if (this.modifysearchObj.child + this.modifysearchObj.adult < 9) {
      this.modifysearchObj.child++;

      this.AddNewchildAge();
      this.ChangeChildAge(this.modifysearchObj.child);



    }

  }
  AddNewchildAge() {
    this.ChangeChildAge(this.modifysearchObj.child);
    if (this.modifysearchObj.child || this.modifysearchObj.infant > 9) {
      this.childAge = true;

      let one = document.getElementById("minusChild") as HTMLButtonElement;
      one.style.color = "var(--first-color-second)";


    }


    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Maximunm 9 Passengers can be added..!' });

    }
  }
  decrementcountChild() {
    if (this.modifysearchObj.child > 0) {
      this.modifysearchObj.child--;

      if (this.modifysearchObj.child == 0) {
        this.childAge = false;
        let one = document.getElementById("minusChild") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      let indexToRemove = 0;
      this.RemoveChild(indexToRemove);
    }
  }
  RemoveChild(i: any) {
    if (this.childAgeListOf.length > 0)
      this.childAgeListOf.splice(i, 1);
  }
  RemoveInfant(i: any) {
    if (this.infantAgeListOf.length > 0)
      this.infantAgeListOf.splice(i, 1);
  }
  ChangeChildAge(value: number) {
    try {
      if (value != 0) {




        this.childAgeListOf.splice(0, this.childAgeListOf.length);

        for (let p = 0; p < value; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValue;
          this.childAgeListOf.push(this.childAgeObj);
        }
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "flex";
      }
      else {
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "none";
        this.childAgeListOf.splice(0, this.childAgeListOf.length);
      }

    }
    catch (ex) {
      console.log(ex);
    }

  }
  ChangeOnewayInfantAge(infValue: number) {
    try {
      if (infValue != 0) {




        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
        for (let p = 0; p < infValue; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValue;
          this.infantAgeListOf.push(this.infantAgeObj);
        }
        var inAgeCont = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeCont.style.display = "flex";
      }
      else {
        var inAgeContNo = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeContNo.style.display = "none";
        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }
  incrementcountInfant() {

    if (this.modifysearchObj.infant < this.modifysearchObj.adult) {
      this.modifysearchObj.infant++;
      this.AddNewInfantAge();
      this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
    }
  }
  AddNewInfantAge() {
    this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
    if (this.modifysearchObj.infant > 0) {
      this.InfantAge = true;
      let one = document.getElementById("minusInfant") as HTMLButtonElement;
      one.style.color = "var(--first-color-second)";


    }


    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Maximunm 9 Passengers can be added..!' });
    }
  }
  decrementcountInfant() {
    if (this.modifysearchObj.infant > 0) {
      this.modifysearchObj.infant--;
      if (this.modifysearchObj.infant == 0) {
        this.InfantAge = false;
        let one = document.getElementById("minusInfant") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      let InfantToRemove = 0;
      this.RemoveInfant(InfantToRemove);
    }
  }
  calculateSum() {
    this.Dropdownadults();
    this.finalcountofpassengers = this.modifysearchObj.adult + this.modifysearchObj.child + this.modifysearchObj.infant;
    if (this.modifysearchObj.adult > 0) {
      this.AllTravelers = false;
      this.Adulttravlers = true;
    }
    if (this.modifysearchObj.child > 0 || this.modifysearchObj.infant > 0) {
      this.AllTravelers = true;
      this.Adulttravlers = false;
    }
    if (this.modifysearchObj.adult == 0 && this.modifysearchObj.child == 0 && this.modifysearchObj.infant == 0) {
      this.AllTravelers = false;
      this.Adulttravlers = true;
    }
  }
  addflightmulti() {
    this.dataFormSubmitoneway = false;
    if (this.modifysearchObj.flightLocationInfo.length < 7) {
      let flight = new FlightSearchDestinationProperties();
      this.modifysearchObj.flightLocationInfo.push(flight);
    }


  }
  removeflightMulti(index) {
    if (index !== -1) {
      this.modifysearchObj.flightLocationInfo.splice(index, 1);
    }
  }
  showtoggleflighttypeDiv(divNumber: number): void {
    this.dataFormSubmitoneway = false
    if (divNumber == 1) {
      this.activesearch = ActiveModifySearch.Oneway;

    }
    else if (divNumber == 2) {
      this.activesearch = ActiveModifySearch.RoundTrip;
    }
    else if (divNumber == 3) {
      this.activesearch = ActiveModifySearch.Multicity;
    }
    this.selectedDiv = divNumber;
    if (this.searchObj.journeyType == divNumber) {
      this.modifysearchObj = JSON.parse(JSON.stringify(this.searchObj));
      this.modifysearchObj.childAges
      return;
    }
    if (this.initialsearch != divNumber) {
      this.modifysearchObj.flightLocationInfo = [];
      this.modifysearchObj.cabinClass = "Economy";
      if (divNumber == 1) {

        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        this.modifysearchObj.journeyType = 1;
        this.activesearch = ActiveModifySearch.Oneway;

      }
      else if (divNumber == 2) {

        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        this.modifysearchObj.journeyType = 2;
        this.activesearch = ActiveModifySearch.RoundTrip;
      }
      else if (divNumber == 3) {
        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        let flights = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flights);
        this.modifysearchObj.journeyType = 3;
        this.activesearch = ActiveModifySearch.Multicity;
      }
    }
    else {
      if (divNumber == 1) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.onewaymodifysearchObj));
      }
      else if (divNumber == 2) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.roundmodifysearchObj));
      }
      else if (divNumber == 3) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.multicitymodifysearchObj));
      }
    }
  }
  onselctMultiDate(f) {
    if (f != 0) {
      for (let i: number = 1; i < this.modifysearchObj.flightLocationInfo.length; i++) {
        if (this.modifysearchObj.flightLocationInfo[i].departureDate < this.modifysearchObj.flightLocationInfo[i - 1].departureDate) {
          this.dataFormSubmitoneway = true;
          return;
        }
      }
    }

  }
  addDaysReturn(e) {


    let days = Number(e.target.value);

    let dateDepartLong: Date = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
    dateDepartLong.setDate(dateDepartLong.getDate() + days);
    dateDepartLong.setHours(0);
    dateDepartLong.setMinutes(0);
    dateDepartLong.setSeconds(0);
    dateDepartLong.setMilliseconds(0);
    let datePipe: DatePipe = new DatePipe('en-US');
    this.modifysearchObj.returnDate = (datePipe.transform(dateDepartLong, "yyyy-MM-dd"));

  }

  DateMinMaxMulti() {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = (month === 0) ? 11 : month;
    let prevYear = (prevMonth === 11) ? year : year;
    let nextMonth = (month === 11) ? 0 : month + 1;
    let nextYear = (nextMonth === 0) ? year + 1 : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);
  }
  searchReadyToBack(searchfromflightSearch: boolean) {
    this.initialsearch = this.activesearch;
    if (this.activesearch == 1) {
      this.onewaymodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    else if (this.activesearch == 2) {
      this.roundmodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    else if (this.activesearch == 3) {
      this.multicitymodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    if (searchfromflightSearch) {
      this.childAgeListOf = this.modifysearchObj.childAges.reduce(function (s, a) {
        s.push({ childAge: Number(a) });
        return s;
      }, []);
      this.infantAgeListOf = this.modifysearchObj.infantAges.reduce(function (s, a) {
        s.push({ infantAge: a });
        return s;
      }, []);
    }
    else {
      this.modifysearchObj.childAges = [];
      this.modifysearchObj.infantAges = [];
    }

    this.modifysearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy") || '';
    for (let n = 0; n < this.childAgeListOf.length; n++) {
      this.modifysearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
    }
    for (let q = 0; q < this.infantAgeListOf.length; q++) {
      this.modifysearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
      if (this.modifysearchObj.infantAges[q] == "less than 1") {
        this.modifysearchObj.infantAges[q] = "0";
      } else if (this.modifysearchObj.infantAges[q] == "1") {
        this.modifysearchObj.infantAges[q] = "1";
      }
      else if (this.modifysearchObj.infant == 0) {
        this.modifysearchObj.infantAges.splice(0, this.modifysearchObj.infantAges.length);
      }
    }

    if (this.modifysearchObj.journeyType == 1 && this.activesearch == ActiveModifySearch.Oneway) {
      console.log(this.modifysearchObj);
      this.modifysearchObj.tripType = "single-round";
      if (!searchfromflightSearch) {
        this.onewaySearchClick();
      }
    }
    if (this.modifysearchObj.journeyType == 2 && this.activesearch == ActiveModifySearch.RoundTrip) {
      console.log(this.modifysearchObj);
      this.modifysearchObj.tripType = "single-round";
      if (!searchfromflightSearch) {
        if (this.bookingObj.providerCode == 'FZ') {
          //this.flyDubaiModifyDateSelection('addTraveler')
          this.openModalRetDates();
  
        } else {
          this.RoundtripSearchClick();
        }
      }
    }
    if (this.modifysearchObj.journeyType == 3 && this.activesearch == ActiveModifySearch.Multicity) {
      this.modifysearchObj.tripType = "multi";
      for (let i: number = 1; i < this.modifysearchObj.flightLocationInfo.length; i++) {
        if (this.modifysearchObj.flightLocationInfo[i].departureDate < this.modifysearchObj.flightLocationInfo[i - 1].departureDate) {
          return;
        }
      }
      if (!searchfromflightSearch) {
        this.MultiCitySearchClick();
      }
    }
  }
  ModifySearchClick(dataform: any) {

    this.dataFormSubmitoneway = true;
    if (dataform.invalid) {
      return;
    }
    if (this.modifysearchObj.journeyType == 1) {
      this.flightsBeforeLoad = true;
    }
    else if (!(this.modifysearchObj.journeyType == 2 && this.bookingObj.providerCode == 'FZ')) {
      this.flightsBeforeLoad = true;
    }
    this.searchReadyToBack(false);
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Modify Search Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/



  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Slider Cards View Price Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/

  nextSlide() {
    const totalSlides = document.querySelectorAll('.slide').length;
    if (this.currentIndex < totalSlides - 5) {
      this.currentIndex++;
      this.updateSlider();
    }
  }
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }
  updateSlider() {
    const sliderElement = this.slider.nativeElement;
    const slideWidth = this.slide.nativeElement.offsetWidth;
    sliderElement.style.transform = `translateX(${-this.currentIndex * slideWidth}px)`;
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Slider Cards View Price Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/




  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight search one way round way multicity search click Work start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  GetAgencyMasterForPrint() {
    this.flightService.GetAgencyForPrint(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.AgencyData = data;
      //console.log(this.AgencyData.agencyName);
      // console.log(this.AgencyData);
    });
  }
  openotherDetails(type: number, index: number) {

    if (OtherFlightDetailsNames.ChangeBooking == type) {

      let checkflight = false;
      if (this.displayedFlights[index].rbdSegments != null) {
        checkflight = false
        if (this.displayedFlights[index].rbdSegments.length > 0) {
          checkflight = false;
          this.changebookingdetailsopen[index] = true;
        }
        else {
          checkflight = true;
        }
      } else {
        checkflight = true;
      }
      if (checkflight) {
        this.flightsBeforeLoad = true;
        let changeParamGallelio = new ChangeRBDParamsGalileo();
        changeParamGallelio.flightScheduleNew = this.displayedFlights[index];
        this.getFlightResultService.GetRBDsForChangeBooking(changeParamGallelio).subscribe((flight) => {
          this.flightsBeforeLoad = false;
          if (flight != null) {
            if (flight.rbdSegments != null) {
              if (flight.rbdSegments.length > 0) {

                this.changebookingdetailsopen[index] = true;
                this.displayedFlights[index].rbdSegments = flight.rbdSegments;

              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking at this Moment' });
              }
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking at this Moment' });
            }
          }

          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking at this Moment' });
          }

        });
      }
    }
    else if (OtherFlightDetailsNames.Baggage == type) {
      if (this.displayedFlights[index].departureFlight.supplier == "SG") {
        let changerbd = new ChangeRBDParamsGalileo();
        changerbd.transactionIdentifier = this.displayedFlights[index].transactionIdentifier;
        changerbd.supplierpricingSolution = this.displayedFlights[index].supplierPricingSolution;
        changerbd.flightSearch = this.modifysearchObj;
        this.flightService.spiceBaggage(changerbd).subscribe((bagslist) => {
          if (bagslist.length > 0) {
            this.displayedFlights[index].frontBaggageAllowance = bagslist;
            this.baggagedetailsopen[index] = true;
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Availiable' });
          }
        })

      }
      else {
        if (this.displayedFlights[index].frontBaggageAllowance.length == 0) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Availiable' });
          return;
        }
        this.baggagedetailsopen[index] = true;
      }

    }
    else if (OtherFlightDetailsNames.FareRules == type) {
      if (this.displayedFlights[index].fareRulesAfterShowAvailiable && (this.oneWayResults || this.roundTripResults)) {
        this.OnewayReturnFareRules(index);

      }
      else {

        this.farerulesopen[index] = true;
      }

    }
    else if (OtherFlightDetailsNames.Print == type) {
      if (this.initialsearch == 1) {
        this.flightresultadditionalProcessts.printClickOneWay(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
          this.flightsBindList, this.initialsearch);
      }
      else if (this.initialsearch == 2) {
        this.flightresultadditionalProcessts.ReturnPrintClick(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
          this.flightsBindList, this.initialsearch);
      }
      else if (this.initialsearch == 3) {
        this.flightresultadditionalProcessts.printClickMulticity(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
          this.flightsBindList, this.initialsearch);
      }
    }
    else if (OtherFlightDetailsNames.Email == type) {
      this.emailpopupopen = true;
      this.emailpopupFlightIndex = index;

    }
    else if (OtherFlightDetailsNames.Brands == type) {
      this.multibranderrormessage = false;
      if (this.displayedFlights[index].brands == null) {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
        return;
      }
      if (this.initialsearch == 1 || this.initialsearch == 2) {
        this.displayedFlights[index].bySectorBrands = [];
        if (!this.displayedFlights[index].allBrandsForAllSectorCheck) {
          for (let f = 0; f < this.modifysearchObj.flightLocationInfo.length; f++) {
            let sectorbrand = new BySectorBrands();
            sectorbrand.fromAirport = this.modifysearchObj.flightLocationInfo[f].fromAirport;
            sectorbrand.toAirport = this.modifysearchObj.flightLocationInfo[f].toAirport;
            if (f == 0) {
              sectorbrand.brandsList = this.displayedFlights[index].brands;
            }
            else if (f == 1) {
              sectorbrand.brandsList = this.displayedFlights[index].returnBrands;
            }

            this.displayedFlights[index].bySectorBrands.push(sectorbrand);
          }
        }
        else if (this.displayedFlights[index].allBrandsForAllSectorCheck) {
          let sectorbrand = new BySectorBrands();
          sectorbrand.fromAirport = this.modifysearchObj.flightLocationInfo[0].fromAirport;
          sectorbrand.toAirport = this.modifysearchObj.flightLocationInfo[this.modifysearchObj.flightLocationInfo.length - 1].toAirport;
          sectorbrand.brandsList = this.displayedFlights[index].brands;
          this.displayedFlights[index].bySectorBrands.push(sectorbrand);
        }
      }
      if (this.displayedFlights[index].bySectorBrands.length > 0) {


        for (let k = 0; k < this.displayedFlights[index].bySectorBrands.length; k++) {
          this.displayedFlights[index].bySectorBrands[k].brandsindex = false;
        }
        this.flightsectorIndexlist = [];
        this.priceOfBrand = 0;
        for (let is = 0; is < this.displayedFlights[index].bySectorBrands.length; is++) {
          let flighobj = new flightsectorIndex();
          this.flightsectorIndexlist.push(flighobj);
        }
        this.displayedFlights[index].bySectorBrands[0].brandsindex = true;
        this.brandDetailsopen[index] = true;
      }
      else {
        //no brands Available
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
      }
    }
    else if (OtherFlightDetailsNames.FlightDetails == type) {
      this.flightDetailsopen[index] = true;
    }
    else if (OtherFlightDetailsNames.CombinationBrands == type) {
      this.multibranderrormessage = false;
      if (this.displayedFlights[index].combinationOfBrands == null) {
        if (this.displayedFlights[index].combinationOfBrands.length == 0) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
          return;
        }
      }
      this.flightsectorIndexlist = [];
      this.priceOfBrand = 0;
      for (let is = 0; is < this.displayedFlights[index].combinationOfBrands.length; is++) {
        let flighobj = new flightsectorIndex();
        this.flightsectorIndexlist.push(flighobj);
      }
      if (this.displayedFlights[index].combinationOfBrands.length > 0) {
        this.brandCombinationDetailsopen[index] = true;
      }
      else {
        //no brands Available
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
      }
    }
  }
  emailClick(form: any) {
    this.emailpopupValidateCheck = true;
    if (form.invalid) {
      return;
    }
    if (this.initialsearch == 1 || this.initialsearch == 2) {
      /*      this.loaderSending = true;*/
      let emailObj: EmailItineraryProperties = this.flightresultadditionalProcessts.sendEmails(this.displayedFlights[this.emailpopupFlightIndex], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
        this.flightsBindList, this.initialsearch);
      if (emailObj.body == null) {
        this.loaderSending = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error While Adding Data' });
      }
      else {
        this.emailService.emailItinerary(this.emailObj).subscribe((data) => {
          this.loaderSending = false;
          if (data == true) {
            this.emailpopupopen = false;
            this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Email Successfully Sent' });


          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Email Not Sent' });
          }

        });
      }
    }
    else if (this.initialsearch == 3) {
      this.loaderSending = true;
      let checkindex = 0;
      if (!this.emailObj.includeAllResults) {
        checkindex = this.emailpopupFlightIndex;
      }
      let emailObj: EmailItineraryProperties = this.flightresultadditionalProcessts.sendEmailMulticity1(checkindex, this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
        this.flightsBindList, this.initialsearch);
      if (emailObj.body == null) {
        this.loaderSending = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error While Adding Data' });
      }
      else {
        this.emailService.emailItinerary(this.emailObj).subscribe((data) => {
          this.loaderSending = false;
          if (data == true) {
            this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Email Successfully Sent' });


          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Email Not Sent' });
          }

        });
      }
    }
  }
  onewaySearchClick() {
    this.oneWayResults = true;
    this.roundTripResults = false;
    this.multicityResults = false;

    this.sentToBacksearchObj = new FlightSearchProperties();
    this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    this.sentToBacksearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    let deplist = this.modifysearchObj.flightLocationInfo[0].fromAirport.split("-");
    let start = deplist[0];
    let tolist = this.modifysearchObj.flightLocationInfo[0].toAirport.split("-");
    let start1 = tolist[0];
    this.modifysearchObj.flightLocationInfo[0].fromCity = start.trim();
    this.modifysearchObj.flightLocationInfo[0].toCity = start1.trim();

    for (let i = 0; i < this.airportList.length; i++) {
      if (this.modifysearchObj.flightLocationInfo[0].fromCity.trim() == this.airportList[i].iatA_CODE) {
        this.modifysearchObj.flightLocationInfo[0].combineAirportFrom = this.airportList[i].combineAirportFrom;
        break;
      }
    }
    for (let i = 0; i < this.airportList.length; i++) {
      if (this.modifysearchObj.flightLocationInfo[0].toCity.trim() == this.airportList[i].iatA_CODE) {
        this.modifysearchObj.flightLocationInfo[0].combineAirportTo = this.airportList[i].combineAirportTo;
        break;
      }
    }
    for (let n = 0; n < this.childAgeListOf.length; n++) {
      this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
    }
    for (let q = 0; q < this.infantAgeListOf.length; q++) {
      this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
      if (this.sentToBacksearchObj.infantAges[q] == "less than 1") {
        this.sentToBacksearchObj.infantAges[q] = "0";
      }
      else if (this.modifysearchObj.infant == 0) {
        this.sentToBacksearchObj.infantAges.splice(0, this.sentToBacksearchObj.infantAges.length);
      }
    }

    this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
    const deptdate = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
    this.modifysearchObj.flightLocationInfo[0].departureDate = this.formatDate(deptdate);
    this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo));

    // History
    let searchHistoryObj = new FlightSearchHistory();
    searchHistoryObj.agencyId = localStorage.getItem("AgencyId") || '';
    searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
    searchHistoryObj.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
    searchHistoryObj.toAirport = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
    searchHistoryObj.fromCity = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
    searchHistoryObj.toCity = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
    searchHistoryObj.departureDate = String(this.sentToBacksearchObj.flightLocationInfo[0].departureDate);
    searchHistoryObj.tripType = "Oneway";
    searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
    searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
    searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
    searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
    searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
    searchHistoryObj.adults = this.sentToBacksearchObj.adult;
    searchHistoryObj.children = this.sentToBacksearchObj.child;
    searchHistoryObj.infants = this.sentToBacksearchObj.infant;
    searchHistoryObj.returnDate = "N/A";
    searchHistoryObj.fromAirportReturn = "N/A";
    searchHistoryObj.toAirportReturn = "N/A";
    searchHistoryObj.fromCityReturn = "N/A";
    searchHistoryObj.toCityReturn = "N/A";
    this.addFlightSearchHistory(searchHistoryObj);
    this.GetAllFlightResults();
  }
  RoundtripSearchClick() {
    try {
      this.oneWayResults = false;
      this.roundTripResults = true;
      this.multicityResults = false;
      let flightlocation = new FlightSearchDestinationProperties();
      this.sentToBacksearchObj = new FlightSearchProperties();
      this.sentToBacksearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
      this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
      this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      const deptdate = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
      this.modifysearchObj.flightLocationInfo[0].departureDate = this.formatDate(deptdate);
      const returndate = new Date(this.modifysearchObj.returnDate);
      this.modifysearchObj.returnDate = this.formatDate(returndate);
      flightlocation = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo[0]));
      let deplist = flightlocation.fromAirport.split("-");
      let start = deplist[0];
      let tolist = flightlocation.toAirport.split("-");
      let start1 = tolist[0];
      let fligthlocationlist = FlightSearchDestinationProperties[0];
      fligthlocationlist = [];
      let flightlocation1 = new FlightSearchDestinationProperties();
      fligthlocationlist.push(flightlocation1);
      let flightlocation2 = new FlightSearchDestinationProperties();
      fligthlocationlist.push(flightlocation2);
      for (let f = 0; f < fligthlocationlist.length; f++) {
        fligthlocationlist[f] = new FlightSearchDestinationProperties();
        if (f == 0) {
          fligthlocationlist[f].fromCity = start.trim();
          fligthlocationlist[f].fromAirport = flightlocation.fromAirport;
          fligthlocationlist[f].departureDate = flightlocation.departureDate;
          fligthlocationlist[f].toAirport = flightlocation.toAirport;
          fligthlocationlist[f].toCity = start1.trim();
          if (this.modDep) {
            fligthlocationlist[f].modifyDeparture = this.modDep;
            if (this.modDep == true) {
              this.oneWayResults = true;
              this.roundTripResults = false;
            }
           
          }
        }
        if (f == 1) {
          fligthlocationlist[f].fromCity = start1.trim();
          fligthlocationlist[f].fromAirport = flightlocation.toAirport;
          fligthlocationlist[f].departureDate = this.modifysearchObj.returnDate;
          fligthlocationlist[f].toAirport = flightlocation.fromAirport;
          fligthlocationlist[f].toCity = start.trim();
          if (this.modRet) {
            fligthlocationlist[f].modifyReturn = this.modRet;
            if (this.modRet) {
              this.oneWayResults = true;
              this.roundTripResults = false;
            } 
          }
        }
      }
      this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(fligthlocationlist));

      for (let f = 0; f < this.sentToBacksearchObj.flightLocationInfo.length; f++) {
        for (let i = 0; i < this.airportList.length; i++) {
          if (this.sentToBacksearchObj.flightLocationInfo[f].fromCity.trim() == this.airportList[i].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[f].combineAirportFrom = this.airportList[i].combineAirportFrom;
            break;
          }
        }
        for (let i = 0; i < this.airportList.length; i++) {
          if (this.sentToBacksearchObj.flightLocationInfo[f].toCity.trim() == this.airportList[i].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[f].combineAirportTo = this.airportList[i].combineAirportTo;
            break;
          }
        }
      }
      for (let n = 0; n < this.childAgeListOf.length; n++) {
        this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
      }
      for (let q = 0; q < this.infantAgeListOf.length; q++) {
        this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
        if (this.sentToBacksearchObj.infantAges[q] == "less than 1") {
          this.sentToBacksearchObj.infantAges[q] = "0";
        }
        else if (this.modifysearchObj.infant == 0) {
          this.sentToBacksearchObj.infantAges.splice(0, this.sentToBacksearchObj.infantAges.length);
        }
      }




      let searchHistoryObj = new FlightSearchHistory();
      searchHistoryObj.agencyId = localStorage.getItem("AgencyId") || '';
      searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
      searchHistoryObj.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
      searchHistoryObj.toAirport = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
      searchHistoryObj.fromCity = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
      searchHistoryObj.toCity = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
      searchHistoryObj.departureDate = String(this.sentToBacksearchObj.flightLocationInfo[0].departureDate);
      searchHistoryObj.returnDate = String(this.sentToBacksearchObj.flightLocationInfo[this.sentToBacksearchObj.flightLocationInfo.length - 1].departureDate);
      searchHistoryObj.tripType = "Roundway";
      searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
      searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
      searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
      searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
      searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
      searchHistoryObj.duration = String(this.sentToBacksearchObj.days);
      searchHistoryObj.adults = this.sentToBacksearchObj.adult;
      searchHistoryObj.children = this.sentToBacksearchObj.child;
      searchHistoryObj.infants = this.sentToBacksearchObj.infant;
      searchHistoryObj.fromAirportReturn = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
      searchHistoryObj.toAirportReturn = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
      searchHistoryObj.fromCityReturn = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
      searchHistoryObj.toCityReturn = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
      this.addFlightSearchHistory(searchHistoryObj);
      this.GetAllFlightResults();
    }
    catch (e) { console.log(e) }
  }
  MultiCitySearchClick() {
    try {
      this.oneWayResults = false;
      this.roundTripResults = false;
      this.multicityResults = true;
      this.sentToBacksearchObj = new FlightSearchProperties();
      this.sentToBacksearchObj.adult = this.modifysearchObj.adult;
      this.sentToBacksearchObj.infant = this.modifysearchObj.infant;
      this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.sentToBacksearchObj.child = this.modifysearchObj.child;
      this.sentToBacksearchObj.tripType = "multi";
      this.sentToBacksearchObj.fareType = this.modifysearchObj.fareType;
      this.sentToBacksearchObj.cabinClass = this.modifysearchObj.cabinClass;
      for (let n = 0; n < this.childAgeListOf.length; n++) {
        this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
      }
      for (let q = 0; q < this.infantAgeListOf.length; q++) {
        this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
        if (this.sentToBacksearchObj.infantAges[q] == "less than 1") {
          this.sentToBacksearchObj.infantAges[q] = "0";
        }
        else if (this.modifysearchObj.infant == 0) {
          this.sentToBacksearchObj.infantAges.splice(0, this.sentToBacksearchObj.infantAges.length);
        }
      }
      this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
      this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo));
      for (let i = 0; i < this.sentToBacksearchObj.flightLocationInfo.length; i++) {
        let start = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.indexOf(this.sentToBacksearchObj.flightLocationInfo[i].fromAirport[0]);
        let end = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.indexOf('-');
        this.sentToBacksearchObj.flightLocationInfo[i].fromCity = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.slice(start, end).trim();
        let start1 = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.indexOf(this.sentToBacksearchObj.flightLocationInfo[i].toAirport[0]);
        let end1 = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.indexOf('-');
        this.sentToBacksearchObj.flightLocationInfo[i].toCity = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.slice(start, end).trim();
        const depdates = new Date(this.sentToBacksearchObj.flightLocationInfo[i].departureDate);
        this.sentToBacksearchObj.flightLocationInfo[i].departureDate = this.formatDate(depdates);
        for (let j = 0; j < this.airportList.length; j++) {
          if (this.sentToBacksearchObj.flightLocationInfo[i].fromCity.trim() == this.airportList[j].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[i].combineAirportFrom = this.airportList[j].combineAirportFrom;
            break;
          }
        }
        for (let k = 0; k < this.airportList.length; k++) {
          if (this.sentToBacksearchObj.flightLocationInfo[i].toCity.trim() == this.airportList[k].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[i].combineAirportTo = this.airportList[k].combineAirportTo;
            break;
          }
        }
      }
      // History
      let searchHistoryObj = new FlightSearchHistory();
      searchHistoryObj.agencyId = localStorage.getItem("AgencyId");
      searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
      for (let b = 0; b < this.sentToBacksearchObj.flightLocationInfo.length; b++) {
        searchHistoryObj.fromAirport += this.sentToBacksearchObj.flightLocationInfo[b].fromAirport + ", ";
        searchHistoryObj.toAirport += this.sentToBacksearchObj.flightLocationInfo[b].toAirport + ", ";
        searchHistoryObj.departureDate += this.sentToBacksearchObj.flightLocationInfo[b].departureDate + ", ";
        searchHistoryObj.fromCity += this.sentToBacksearchObj.flightLocationInfo[b].fromCity + ", ";
        searchHistoryObj.toCity += this.sentToBacksearchObj.flightLocationInfo[b].toCity + ", ";
      }
      let fromAirports = searchHistoryObj.fromAirport.trimRight();
      let toAirports = searchHistoryObj.toAirport.trimRight();
      let departureDates = searchHistoryObj.departureDate.trimRight();
      let fromCities = searchHistoryObj.fromCity.trimRight();
      let toCities = searchHistoryObj.toCity.trimRight();
      searchHistoryObj.fromAirport = fromAirports.slice(0, -1);
      searchHistoryObj.toAirport = toAirports.slice(0, -1);
      searchHistoryObj.departureDate = departureDates.slice(0, -1);
      searchHistoryObj.fromCity = fromCities.slice(0, -1);
      searchHistoryObj.toCity = toCities.slice(0, -1);
      searchHistoryObj.tripType = "Multi City";
      searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
      searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
      searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
      searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
      searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
      searchHistoryObj.adults = this.sentToBacksearchObj.adult;
      searchHistoryObj.children = this.sentToBacksearchObj.child;
      searchHistoryObj.infants = this.sentToBacksearchObj.infant;
      searchHistoryObj.returnDate = "N/A";
      this.addFlightSearchHistory(searchHistoryObj);
      this.GetAllFlightResults();


    }
    catch (e) { console.log }
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // months are 0-based
    return `${year}-${month}-${day}`;
  }


  GetAllFlightResults() {
    try {
      if (this.bookingObj.providerCode == "FZ") {

        this.modifyFlights.flightSearch = this.sentToBacksearchObj;
        this.modifyFlights.bookingInfo = this.bookingObj;
        this.partial = false;
        let partialCount = 0;
        if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
          for (let a = 0; a < this.modifyFlights.flightSearch.flightLocationInfo.length; a++) {
            if (a == 0 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyDeparture == true) {
              partialCount++;
            }
            else if ((a == 1 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyReturn == true)) {
              partialCount++;
            }
          }
        }
        else {
          this.partial = false;
        }

        if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
          if (partialCount == 1) {
            this.partial = true;
          }
          else {
            this.partial = false;
          }
        } else {
          this.partial = true;
        }

        if (this.partial == false) {
          this.partialMessage = "One Segment can be change at a time.";
          document.querySelector(".partial-msg").innerHTML = this.partialMessage;
          return;
        }




      }//fz condition
    } catch (e) {
      console.log(e);
    }


    this.flightsloading = true;
    this.noflightavailable = false;
    this.sliderAirlineShow = true;
    this.flightshortCountSkelton = [];
    this.flightshortCountSkelton.push(1);
    this.flightshortCountSkelton.push(2);
    this.flightshortCountSkelton.push(3);
    this.flightshortCountSkelton.push(4);
    this.batchSize = 100;
    this.startIndex = 0;
    this.flightrequestCounter = 0;
    this.flightresponseCounter = 0;
    this.flighResultObj = new FlightSearchNewResponseProperties();
    this.flighResultObj.flights = [];
    this.flightsBindList = [];
    this.displayedFlights = [];
    this.popoverArray = [];
    this.filtersBinding.airlinesList = [];
    this.filtersBinding.fareType = new FaretypeFilters();
    this.filtersBinding.timeList = new TimeListFilter();
    this.filtersBinding.stopsDetails = new StopFlightFilters();
    this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
    this.filtersBinding.stopsDetails = new StopFlightFilters();
    this.flightsBeforeLoad = false;

    if (this.modifysearchObj.journeyType == 1 || this.modifysearchObj.journeyType == 2) {

      if (this.modifysearchObj.lowCostAirline == true) {

        if (this.bookingObj.providerCode == "FZ") {

          this.flightrequestCounter++;
          this.flightService.FlyDubaiDateJourneyModify(this.modifyFlights).subscribe((fzData) => {
            if (fzData != null) {
              this.modalService.dismissAll();
              this.partial = false;
              let partialCount = 0;
              if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
                for (let a = 0; a < this.modifyFlights.flightSearch.flightLocationInfo.length; a++) {
                  if (a == 0 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyDeparture == true) {
                    partialCount++;
                  }
                  else if ((a == 1 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyReturn == true)) {
                    partialCount++;
                  }
                }
              }
              else {
                this.partial = false;

              }

              if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
                if (partialCount == 1) {
                  this.partial = true;
                }
                else {
                  this.partial = false;
                }
              }


              if (this.partial == false) {
                console.log(fzData.flightSearchResponse.flights);
                this.flighResultObj.flights.push(...fzData.flightSearchResponse.flights);
                this.flightsBindList = this.flightsBindList.concat(...fzData.flightSearchResponse.flights);
                this.loadInitialFilters();
                for (let j = 0; j < this.flightsBindList.length; j++) {
                  this.popoverArray.push(false);
                }
                // this.singleRoundFlightsAccessories(this.flighResultObj);
                this.fzTransactionIdentifier = fzData.token;
                this.retrivePnrResp = fzData.retrievePNRResponse;
                this.flightLoaderClose();
              }
              else {
                console.log(fzData.flightSearchResponse.flights);
                this.flighResultObj.flights.push(...fzData.flightSearchResponse.flights);
                this.flightsBindList = this.flightsBindList.concat(...fzData.flightSearchResponse.flights);
                this.loadInitialFilters();

                for (let j = 0; j < this.flightsBindList.length; j++) {
                  this.popoverArray.push(false);
                }
                // this.partialFlightsAccessories(this.flighResultObj);
                this.fzTransactionIdentifier = fzData.token;
                this.retrivePnrResp = fzData.retrievePNRResponse;
                this.flightLoaderClose();
              }
            }
          },
            error => {
              console.error(error);
              this.flightLoaderClose();
            });
        }
        else if (this.bookingObj.providerCode == "AI" || this.bookingObj.providerCode == "EK") {
          try {
            let flightsearchObj = new FlightSearchPropModify();
            flightsearchObj.searchObj = this.sentToBacksearchObj;
            flightsearchObj.bookingInfo = this.bookingObj;
            this.flightrequestCounter++;
            this.getFlightResultService.GetFlightResultAirIndiaModify(flightsearchObj).subscribe(
              result => {
                if (result != null) {
                  if (result.flights != null) {
                    if (result.flights.length > 0) {

                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                      this.flightsBindList = this.flightsBindList.concat(result.flights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );

          } catch (e) {
            console.log(e);
          }
        }
        else if (this.bookingObj.providerCode == "PA") {
          try {
            this.flightrequestCounter++;
            this.getFlightResultService.GetFlightResultAirBlueT4Travels(this.sentToBacksearchObj).subscribe(
              result => {
                if (result != null) {
                  if (result.flights != null) {
                    if (result.flights.length > 0) {

                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                      this.flightsBindList = this.flightsBindList.concat(result.flights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );

          } catch (e) {
            console.log(e);
          }
          try {
            this.flightrequestCounter++;
            this.getFlightResultService.GetFlightResultAirBlue(this.sentToBacksearchObj).subscribe(
              result => {
                if (result != null) {
                  if (result.flights != null) {
                    if (result.flights.length > 0) {

                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                      this.flightsBindList = this.flightsBindList.concat(result.flights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );

          } catch (e) {
            console.log(e);
          }
        }
        else if (this.bookingObj.providerCode == "SG") {

          this.modifyFlights.flightSearch = this.sentToBacksearchObj;
          this.modifyFlights.bookingInfo = this.bookingObj;
          //let modifySearchData = JSON.stringify(this.modifyFlights);
          this.flightrequestCounter++;
          this.flightService.modifySpiceBooking(this.modifyFlights).subscribe(
            result => {
              if (result != null) {
                if (result.flightSearchResponse.flights != null) {
                  if (result.flightSearchResponse.flights.length > 0) {

                    this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flightSearchResponse.flights);
                    this.modifyFlights = result;
                    this.flightsBindList = this.flightsBindList.concat(result.flightSearchResponse.flights);
                    this.loadInitialFilters();

                    for (let j = 0; j < this.flightsBindList.length; j++) {
                      this.popoverArray.push(false);
                    }
                  }
                }
              }

              this.flightLoaderClose();
            },
            error => {
              console.error(error);
              this.flightLoaderClose();
            }
          );

        }
      }
    }
    if (this.modifysearchObj.journeyType == 3) {
      if (this.bookingObj.providerCode == "PA") {
        try {
          this.flightrequestCounter++;
          this.getFlightResultService.AirBlueMulticityFlightResult(this.sentToBacksearchObj).subscribe(
            result => {
              if (result != null) {
                if (result.allMultiFlights != null) {
                  if (result.allMultiFlights.length > 0) {

                    this.flighResultObj.flights = this.flighResultObj.flights.concat(result.allMultiFlights);

                    this.flightsBindList = this.flightsBindList.concat(result.allMultiFlights);
                    this.loadInitialFilters();

                    for (let j = 0; j < this.flightsBindList.length; j++) {
                      this.popoverArray.push(false);
                    }
                  }
                }
              }

              this.flightLoaderClose();
            },
            error => {
              console.error(error);
              this.flightLoaderClose();
            }
          );

        } catch (e) {
          console.log(e);
        }
        try {
          this.flightrequestCounter++;
          this.getFlightResultService.AirBlueMulticityFlightResultT4Travels(this.sentToBacksearchObj).subscribe(
            result => {
              if (result != null) {
                if (result.allMultiFlights != null) {
                  if (result.allMultiFlights.length > 0) {

                    this.flighResultObj.flights = this.flighResultObj.flights.concat(result.allMultiFlights);

                    this.flightsBindList = this.flightsBindList.concat(result.allMultiFlights);
                    this.loadInitialFilters();

                    for (let j = 0; j < this.flightsBindList.length; j++) {
                      this.popoverArray.push(false);
                    }
                  }
                }
              }

              this.flightLoaderClose();
            },
            error => {
              console.error(error);
              this.flightLoaderClose();
            }
          );

        } catch (e) {
          console.log(e);
        }
      }
    }









  }


  flyDubaiInitials() {

    try {
      this.modifyFlights.flightSearch = this.sentToBacksearchObj;
      this.modifyFlights.bookingInfo = this.bookingObj;
      this.partial = false;
      let partialCount = 0;
      if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
        for (let a = 0; a < this.modifyFlights.flightSearch.flightLocationInfo.length; a++) {
          if (a == 0 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyDeparture == true) {
            partialCount++;
          }
          else if ((a == 1 && this.modifyFlights.flightSearch.flightLocationInfo[a].modifyReturn == true)) {
            partialCount++;
          }
        }
      }
      else {
        this.partial = false;
      }

      if (this.modifyFlights.flightSearch.flightLocationInfo.length > 1) {
        if (partialCount == 1) {
          this.partial = true;
        }
        else {
          this.partial = false;
        }
      } else {
        this.partial = true;
      }

      if (this.partial == false) {
        this.partialMessage = "One Segment can be change at a time."
      }



    } catch (e) {
      console.log(e);
    }



  }





  flightLoaderClose() {
    this.flightresponseCounter++;
    this.progressValue = (this.flightresponseCounter / this.flightrequestCounter) * 100;
    console.log("Response", this.flightresponseCounter);
    if (this.flightrequestCounter == this.flightresponseCounter) {
      if (this.initialsearch != 3) {
        this.minValueSliderFilter = this.getMinPrice(this.flightsBindList, "oneround");
        this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "oneround");
      } else {
        this.minValueSliderFilter = this.getMinPrice(this.flightsBindList, "multi");
        this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "multi");

      }
      if (this.flighResultObj.flights.length > 0) {
        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = false;

      }
      else {
        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = true;
        this.sliderAirlineShow = false;
      }



    }
  }
  addFlightSearchHistory(searchHistoryObj) {
    this.flightService.flightSearchHistoryInsert(searchHistoryObj).subscribe(data => {
      console.log(data);
    });
  }
  getLastAirportForAirsegment(inputString: string): string {
    const parts = inputString.split('-');
    return parts.length > 1 ? parts.slice(2).join(' ') : inputString;
  }
  OnewayReturnFareRules(flightIndex: number) {
    let gal = new ChangeRBDParamsGalileo();
    gal.brandselected = false;
    this.flightsBeforeLoad = true;
    if (this.oneWayResults == true || this.roundTripResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;

      this.flightService.GetFlightFareRules(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null) {
          this.displayedFlights[flightIndex].fareRulesNew = data.flights[0].fareRulesNew;
          this.farerulesopen[flightIndex] = true;
        }
      });



    }
  }


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight search one way round way multicity search click Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight Selection Simple Process Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
openModalRetDates() {
  // Open the modal when component initializes
  this.modalService.open(this.addTravelerModal, { centered: true }); // Open the modal
  return;
}

  commitmodifyflydubaiPOP: boolean = false;
  CommitModifyFlyDubaiRequest(modifyType: string) {
    this.flightsBeforeLoad = true;
    if (modifyType) {
      this.modalfzconfirm = false;
      this.flightService.CommitModifyRequest(this.OrigionalData).subscribe((data) => {
        if (data) {
          this.flightsBeforeLoad = false;
          var bookingid = data.bookingID;
          localStorage.setItem("bookingID", String(bookingid));
          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          this.flightsBeforeLoad = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not Modified!', life: 3000 });
        }

      });
    }
  }
  changeCost: number = 0;
  ReservationBalance: number = 0;
  modifyType: string = "";
  SelectFlight(flightIndex: number, brands: boolean) {
    let gal = new ChangeRBDParamsGalileo();
    gal.brandselected = brands;
    this.flightsBeforeLoad = true;
    if (this.oneWayResults == true || this.roundTripResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      if (brands && this.bookingObj.providerCode == "FZ") {
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].brands[this.brandIndex].supplierPricingSolution;
      } else {
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      }
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;
      if (this.displayedFlights[flightIndex].departureFlight.supplier == "FZ") {
        gal.transactionIdentifier = this.fzTransactionIdentifier;
        gal.selectedFareBrand = this.retrivePnrResp;
      }
      let modifyFlight = new ModifyFlightAirAiternary();
      modifyFlight.bookingInfo = JSON.parse(localStorage.getItem("flightmodifyBookingInfo"));
      modifyFlight.rbdParam = gal;
      modifyFlight.stopsCount = this.displayedFlights[flightIndex].departureFlight.stopCount;
      modifyFlight.modifyUser = Number(localStorage.getItem("UserId"));
      if (this.displayedFlights[flightIndex].departureFlight.supplier == "SG") {
        modifyFlight.oldCancelDetails = this.modifyFlights.modifyMoreData;
        this.flightService.spiceModifySell(gal).subscribe((data) => {
          this.flightsBeforeLoad = false;
          if (data) {

            let requestObj = new BookingBasicProperties();
            requestObj.extraProfit = this.filtersBinding.applyMarkup;
            requestObj.fromAirport = data.flights[0].fromAirport;
            requestObj.brandsSelected = brands;
            requestObj.toAirport = data.flights[0].toAirport;
            requestObj.airportsList = this.airportList;
            requestObj.bookingPCC = data.flights[0].departureFlight.pcc;
            requestObj.airSegment = data.flights[0].airSegmentsNew;
            requestObj.flightProp = this.sentToBacksearchObj;
            requestObj.stopcount = data.flights[0].departureFlight.stopCount;
            requestObj.supplierCode = data.flights[0].departureFlight.supplier;
            requestObj.passengerFares = data.flights[0].passengerFares;
            requestObj.nonRefundable = data.flights[0].departureFlight.nonRefundable;
            requestObj.supplierPricingSolution = data.flights[0].supplierPricingSolution;
            requestObj.transactionIdentifierJ = data.flights[0].transactionIdentifier;
            requestObj.flightscheduleNew = data.flights[0];
            let jsondata = JSON.parse(data.flights[0].frontReusePricingSolution);           
            modifyFlight.newModifyDetails = jsondata.spicenewmodifydetails;
            requestObj.modifyFlight = JSON.stringify(modifyFlight);

            localStorage.setItem('bkdata', JSON.stringify(requestObj));
            this.router.navigateByUrl('/spiceModify');

          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Not Modified', life: 3000 });
          }
        })

      }
      else if (this.displayedFlights[flightIndex].departureFlight.supplier == "FZ") {
        this.flightService.FZAddToCart(modifyFlight).subscribe((data) => {
          let requestObj = new BookingBasicProperties();
          requestObj.extraProfit = this.filtersBinding.applyMarkup;
          this.searchObj.parentHierarchy = this.bookingObj.galileoBookingProp.flightProp.parentHierarchy;
          requestObj.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
          requestObj.airSegment = this.displayedFlights[flightIndex].airSegmentsNew;;
          requestObj.flightProp = this.searchObj;
          requestObj.stopcount = this.displayedFlights[flightIndex].departureFlight.stopCount;
          requestObj.supplierCode = this.displayedFlights[flightIndex].departureFlight.supplier;
          //requestObj.flightLogo = this.displayedFlights[flightIndex].depatureFlight.airlineLogo;
          requestObj.passengerFares = this.displayedFlights[flightIndex].passengerFares;
          requestObj.nonRefundable = this.displayedFlights[flightIndex].departureFlight.nonRefundable;

          this.flightsBeforeLoad = false;
          if (data != null) {
            this.modalfzconfirm = true;
            this.OrigionalData = data;
            this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
            this.changeCost = this.ModifyData.changeCost;
            this.ReservationBalance = this.ModifyData.reservationBalance;
            this.modifyType = this.ModifyData.modifyType;
            this.commitmodifyflydubaiPOP = true;
            this.confirmationService.confirm({
              header: this.ModifyData.modifyType,
              message: 'Please confirm to proceed moving forward.',
              acceptIcon: 'pi pi-check mr-2',
              rejectIcon: 'pi pi-times mr-2',
              rejectButtonStyleClass: 'p-button-sm',
              acceptButtonStyleClass: 'p-button-outlined p-button-sm',
              accept: () => {
                this.flightsBeforeLoad = true;
                this.CommitModifyFlyDubaiRequest(this.ModifyData.modifyType);
              },
              reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Not Modified', life: 3000 });
                this.flightsBeforeLoad = false;
              }
            });
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Error occured', detail: 'Not Modified', life: 3000 });
            this.flightsBeforeLoad = false;
          }


        });
      }
      else {
        this.flightService.ModifyBooking(modifyFlight).subscribe((data) => {
          this.flightsBeforeLoad = false;
          if (data != null) {
            if (data.bookingID != null && data.bookingID != undefined && data.bookingID > 0) {
              localStorage.setItem('bookingID', data.bookingID.toString());
              this.router.navigateByUrl('/ticket-issuance');
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorInfo, life: 3000 });
            }
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorInfo, life: 3000 });
          }
        });
      }
    }
    else if (this.multicityResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].multiFlights[0].pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;
      let modifyFlight = new ModifyFlightAirAiternary();
      modifyFlight.bookingInfo = JSON.parse(localStorage.getItem("flightmodifyBookingInfo"));
      modifyFlight.rbdParam = gal;
      modifyFlight.stopsCount = this.displayedFlights[flightIndex].departureFlight.stopCount;
     
      modifyFlight.modifyUser = Number(localStorage.getItem("UserId"));
      this.flightService.ModifyBooking(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null) {
          if (data.bookingID != null && data.bookingID != undefined && data.bookingID > 0) {
            localStorage.setItem('bookingID', data.bookingID.toString());
            this.router.navigateByUrl('/ticket-issuance');
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorInfo, life: 3000 });
          }
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorInfo, life: 3000 });
        }
      });

    }
  }


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight Selection Simple Process Work end Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Selection Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  showNextBrand(flight, sector): boolean {
    let brands = false;
    if (this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != undefined) {
      this.displayedFlights[flight].bySectorBrands[sector].brandsindex = false;
      this.displayedFlights[flight].bySectorBrands[sector + 1].brandsindex = true;
      this.multibranderrormessage = false;
      brands = true;

    }
    else {
      this.multibranderrormessage = true;


      brands = false;
    }
    return brands;
  }
  showPreviousBrand(flight, sector) {
    this.displayedFlights[flight].bySectorBrands[sector].brandsindex = false;
    this.displayedFlights[flight].bySectorBrands[sector - 1].brandsindex = true;
  }
  brandIndex: number;
  selectBrandFlight(flight, sector, brand) {
    this.brandIndex = brand;
    this.multibranderrormessage = false;
    try {
      //this.flightsectorIndexlist[sector]
      if (flight == this.flightsectorIndexlist[sector].prevflight && this.flightsectorIndexlist[sector].prevsector == sector) {
        var depBtn = document.getElementById(`brand_btn_multi_comb${this.flightsectorIndexlist[sector].prevflight}${this.flightsectorIndexlist[sector].prevsector}${this.flightsectorIndexlist[sector].prevbrand}`) as HTMLButtonElement;
        depBtn.style.backgroundColor = "#4d4766";
        depBtn.style.color = "white";
        depBtn.textContent = "Select";
      }
    }
    catch (e) {
    }
    try {
      var depBtn = document.getElementById(`brand_btn_multi_comb${flight}${sector}${brand}`) as HTMLButtonElement;
      depBtn.style.backgroundColor = "var(--first-color-second)";
      depBtn.style.color = "black";
      depBtn.textContent = "Selected";
    }
    catch (e) {
    }
    this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].supplierPricingSolution;
    this.displayedFlights[flight].bySectorBrands[sector].selectedbrand = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].brandName;
    this.displayedFlights[flight].bySectorBrands[sector].priceofselectedbrand = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].brandPrice;
    this.displayedFlights[flight].bySectorBrands[sector].passengerFares = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].passengerFares;
    this.priceOfBrand = 0;
    for (let p = 0; p < this.displayedFlights[flight].bySectorBrands.length; p++) {
      if (this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != undefined && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != null && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != 0) {
        this.priceOfBrand += this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand;
      }
    }
    this.flightsectorIndexlist[sector].prevbrand = brand;
    this.flightsectorIndexlist[sector].prevsector = sector;
    this.flightsectorIndexlist[sector].prevflight = flight;
  }
  ConfirmSelectBrand(index) {
    let confirmcheck = false;
    try {
      for (let sector = 0; sector < this.displayedFlights[index].bySectorBrands.length; sector++) {
        if (this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != undefined) {
          this.multibranderrormessage = false;
          confirmcheck = true;
        }
        else {
          this.multibranderrormessage = true;
          confirmcheck = false;
        }
      }
      if (confirmcheck) {
        this.SelectFlight(index, true);
      }

    } catch (e) {
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Combination Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/

  selectCombinationBrandFlight(flight, sector, brand) {
    this.multibranderrormessage = false;
    try {
      //this.flightsectorIndexlist[sector]
      if (flight == this.flightsectorIndexlist[sector].prevflight && this.flightsectorIndexlist[sector].prevsector == sector) {
        var depBtn = document.getElementById(`brand_btn_multi_comb${this.flightsectorIndexlist[sector].prevflight}${this.flightsectorIndexlist[sector].prevsector}${this.flightsectorIndexlist[sector].prevbrand}`) as HTMLButtonElement;
        depBtn.style.backgroundColor = "#4d4766";
        depBtn.style.color = "white";
        depBtn.textContent = "Select";
      }
    }
    catch (e) {
    }
    try {
      var depBtn = document.getElementById(`brand_btn_multi_comb${flight}${sector}${brand}`) as HTMLButtonElement;
      depBtn.style.backgroundColor = "var(--first-color-second)";
      depBtn.style.color = "black";
      depBtn.textContent = "Selected";
    }
    catch (e) {
    }
    this.displayedFlights[flight].bySectorBrands = [];
    let bysectorbrand = new BySectorBrands();
    bysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][0].supplierPricingSolution;
    bysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandName;
    bysectorbrand.priceofselectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandPrice;
    bysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][0].passengerFares;
    bysectorbrand.brandsList = [];
    let onewaybrand = new BrandsNew();
    onewaybrand = this.displayedFlights[flight].combinationOfBrands[sector][0];
    bysectorbrand.brandsList.push(onewaybrand);
    this.displayedFlights[flight].bySectorBrands.push(bysectorbrand);
    let returnbysectorbrand = new BySectorBrands();
    returnbysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][1].supplierPricingSolution;
    returnbysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][1].brandName;
    returnbysectorbrand.priceofselectedbrand = 0;
    returnbysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][1].passengerFares;
    returnbysectorbrand.brandsList = [];
    let returnbrand = new BrandsNew();
    returnbrand = this.displayedFlights[flight].combinationOfBrands[sector][1];
    returnbysectorbrand.brandsList.push(returnbrand);
    this.displayedFlights[flight].bySectorBrands.push(returnbysectorbrand);
    this.priceOfBrand = 0;
    for (let p = 0; p < this.displayedFlights[flight].bySectorBrands.length; p++) {
      if (this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != undefined && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != null && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != 0) {
        this.priceOfBrand += this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand;
      }
    }
    this.flightsectorIndexlist[sector].prevbrand = brand;
    this.flightsectorIndexlist[sector].prevsector = sector;
    this.flightsectorIndexlist[sector].prevflight = flight;
  }
  ConfirmCombinationSelectBrand(index) {
    let confirmcheck = false;
    try {
      for (let sector = 0; sector < this.displayedFlights[index].bySectorBrands.length; sector++) {
        if (this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != undefined) {
          this.multibranderrormessage = false;
          confirmcheck = true;
        }
        else {
          this.multibranderrormessage = true;
          confirmcheck = false;
        }
      }
      if (confirmcheck) {
        this.SelectFlight(index, true);
      }

    } catch (e) {
    }
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Combination Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/




  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Cards Price Final Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  toggleWithAnimationOptions(index: number) {
    this.popoverArray[index] = !this.popoverArray[index];
    let totalPrice = 0;
    console.log(this.popoverArray);
    for (let i = 0; i < this.displayedFlights[index].passengerFares.length; i++) {
      totalPrice = Number(this.displayedFlights[index].passengerFares[i].agencyTotalPrice.substring(3));
    }
    this.grossPrice = this.displayedFlights[index].passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
    console.log(this.grossPrice);
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Cards Price Final Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  trackByFlightId(index: number, flight: FlightSchedulesNew): string {
    return flight.departureFlight.departureDate + flight.departureFlight.departure.city + flight.departureFlight.arrival.city + flight.departureFlight.departure.flightNumber + flight.departureFlight.supplier; // or unique identifier property
  }
  trackByFlightIdMulti(index: number, flight: FlightSchedulesNew): string {
    return flight.multiFlights[0].departureDate + flight.multiFlights[0].departure.city + flight.multiFlights[0].arrival.city + flight.multiFlights[0].departure.flightNumber + flight.multiFlights[0].supplier; // or unique identifier property
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Filters Selection Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  airlineSmallCardfilter(filterbyAirline: FilterByAirlineProperties) {
    this.displayedFlights = [];
    let flightnewresult = JSON.parse(JSON.stringify(this.flighResultObj.flights));
    if (this.initialsearch != 3) {
      flightnewresult = flightnewresult.filter(airline =>
        airline.departureFlight.airlineLegalName.toLowerCase().includes(filterbyAirline.airlineName.toLowerCase())
      );
    }
    else {
      flightnewresult = flightnewresult.filter(airline =>
        airline.multiFlights[0].airlineLegalName.toLowerCase().includes(filterbyAirline.airlineName.toLowerCase())
      );
    }


    this.flightsBindList = flightnewresult;
    if (this.initialsearch != 3) {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    else {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    this.batchSize = 100;
    this.startIndex = 0;

    this.loadNextFlights();
  }
  //for min flight price
  getMinPrice(flights: FlightSchedulesNew[], triptype: string): number {
    if (triptype == "multi") {
      let minPrice = Math.min(...flights.map(flight => parseFloat(flight.multiFlights[0].agencyTotalPrice.slice(3))));
      return minPrice;
    }
    else {
      let minPrice = Math.min(...flights.map(flight => parseFloat(flight.departureFlight.agencyTotalPrice.slice(3))));
      return minPrice;
    }

  }
  //for max flight price
  getMaxPrice(flights: FlightSchedulesNew[], triptype: string): number {
    if (triptype == "multi") {
      let maxPrice = Math.max(...flights.map(flight => parseFloat(flight.multiFlights[0].agencyTotalPrice.slice(3))));
      return maxPrice;
    }
    else {
      let maxPrice = Math.max(...flights.map(flight => parseFloat(flight.departureFlight.agencyTotalPrice.slice(3))));
      return maxPrice;
    }
  }

  SliderPriceChange(changeContext) {
    if (changeContext.start != 0 && changeContext.end != 0) {
      if (!isNaN(changeContext.start) && !isNaN(changeContext.end)) {
        this.flightsBindList = this.flightresultadditionalProcessts.FlightPriceFilter(changeContext, this.flighResultObj, this.modifysearchObj);
        this.batchSize = 100;
        this.startIndex = 0;
        let sortedFlights: FlightSchedulesNew[] = [];
        if (this.oneWayResults || this.roundTripResults) {
          sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));

        }
        else if (this.multicityResults) {
          sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));

        }
        this.flightsBindList = sortedFlights;
        this.displayedFlights = [];
        this.loadNextFlights();
      }
    }
  }
  FiltersApply(event, type) {
    let multi: boolean = false;
    if (this.initialsearch == 3) {
      multi = true;
    }
    this.flightsBindList = this.flightresultadditionalProcessts.CombineFilter(event, type, multi, this.flighResultObj.flights, this.filtersBinding, this.modifysearchObj, this.flighResultObj)
    this.batchSize = 100;
    this.startIndex = 0;
    this.displayedFlights = [];
    if (this.initialsearch != 3) {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    else {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    this.loadNextFlights();
    if (this.displayedFlights.length === 0) {
      this.noflightavailable = true;
      this.sliderAirlineShow = false;
    } else {
      this.noflightavailable = false;
      this.sliderAirlineShow = true;
    }
  }
  loadNextFlights() {
    const endIndex = Math.min(this.startIndex + this.batchSize, this.flightsBindList.length);
    this.displayedFlights = this.displayedFlights.concat(this.flightsBindList.slice(this.startIndex, endIndex));



    this.startIndex = endIndex;


  }
  loadInitialFilters() {
    this.batchSize = 100;
    this.startIndex = 0;
    if (this.flightsBindList.length > 0) {
      //sort by lowest price
      if (this.initialsearch != 3) {
        let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
        this.flightsBindList = sortedFlights;
        //show only some flights strategy
        this.displayedFlights = [];
        this.filtersBinding.airlinesList = this.flightresultadditionalProcessts.getAirlineFareSummaries(this.flightsBindList);
        //// for stop count
        const stopsDetailsList = this.flightresultadditionalProcessts.getStopsDetailsSummaries(this.flightsBindList);
        this.filtersBinding.stopsDetails.directFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.directFlights, 0);
        this.filtersBinding.stopsDetails.oneStopFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.oneStopFlights, 0);
        this.filtersBinding.stopsDetails.twoStopPlusFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.twoStopPlusFlights, 0);
        //// for return stop count
        if (this.bookingObj.providerCode != 'FZ') {
        if (this.initialsearch === 2) {
          const ReturnstopsDetailsList = this.flightresultadditionalProcessts.getReturnStopsDetailsSummaries(this.flightsBindList);
          this.filtersBinding.stopsDetailsReturn.returnDirectFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnDirectFlights, 0);
          this.filtersBinding.stopsDetailsReturn.returnOneStopFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnOneStopFlights, 0);
          this.filtersBinding.stopsDetailsReturn.returnTwoStopFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnTwoStopFlights, 0);
        }
      }

        //// for fare type count
        const fareTypeList = this.flightresultadditionalProcessts.getFareTypeSummaries(this.flightsBindList);
        this.filtersBinding.fareType.refundableCountFlights = fareTypeList.refundableCountFlights;
        this.filtersBinding.fareType.nonRefundableCountFlights = fareTypeList.nonRefundableCountFlights;

        //this.minValueSliderFilter = this.getMinPrice(this.flightsBindList,"oneround");
        //this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "oneround");
        this.loadNextFlights();
      }
      else {
        let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
        this.flightsBindList = sortedFlights;
        //show only some flights strategy
        this.displayedFlights = [];
        this.filtersBinding.airlinesList = this.flightresultadditionalProcessts.getAirlineFareSummariesOfMulticity(this.flightsBindList);
        // for stop count
        const stopsDetailsList = this.flightresultadditionalProcessts.getStopsDetailsSummariesMul(this.flightsBindList);
        this.filtersBinding.stopsDetails.directFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.directFlights, 0);
        this.filtersBinding.stopsDetails.oneStopFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.oneStopFlights, 0);
        this.filtersBinding.stopsDetails.twoStopPlusFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.twoStopPlusFlights, 0);

        // for fare type
        const fareTypeList = this.flightresultadditionalProcessts.getFareTypeSummariesMul(this.flightsBindList);
        this.filtersBinding.fareType.refundableCountFlights = fareTypeList.refundableCountFlights;
        this.filtersBinding.fareType.nonRefundableCountFlights = fareTypeList.nonRefundableCountFlights;

        //this.minValueSliderFilter = this.getMinPrice(this.flightsBindList,"multi");
        //this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "multi");
        this.loadNextFlights();
      }


    }
  }

  clearFilter() {
    this.batchSize = 100;
    this.startIndex = 0;
    this.displayedFlights = [];
    this.filtersBinding.airlinesList = [];
    this.filtersBinding.fareType = new FaretypeFilters();
    this.filtersBinding.timeList = new TimeListFilter();
    this.filtersBinding.stopsDetails = new StopFlightFilters();
    this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
    this.flightsBindList = this.flighResultObj.flights;
    this.loadInitialFilters();
  }
  applyMarkUPClick() {
    if (this.filtersBinding.applyMarkup > 0) {
      this.filtersBinding.markupIsChecked = true;
    }
    //* airSeg.length
    if (this.initialsearch == 3 && this.filtersBinding.applyMarkup > 0) {
      for (let i = 0; i < this.flightsBindList.length; i++) {
        let currency: string = this.flightsBindList[i].passengerFares[0].agencyTotalPrice.substring(0, 3);
        let airSeg: AirSegmentsDetailsNew[] = [];
        airSeg = this.flightsBindList[i].airSegmentsNew;
        let totalPassenger = this.searchObj.child + this.searchObj.adult + this.searchObj.infant;
        let addedmarkup = (this.filtersBinding.applyMarkup * totalPassenger) - (this.previousmarkup * totalPassenger);
        // this.totalMarkupPerPassenger = this.markup ;
        let taxAmount: number;
        taxAmount = Number(this.flightsBindList[i].multiFlights[0].agencyTaxAmount.substring(3));
        taxAmount += addedmarkup;
        taxAmount = Number(taxAmount.toFixed(2));
        this.flightsBindList[i].multiFlights[0].totalTaxAmount = currency + taxAmount;
        let totalAmount = Number(this.flightsBindList[i].multiFlights[0].agencyTotalPrice.substring(3));
        totalAmount += addedmarkup;
        //totalAmount += taxAmount;
        this.flightsBindList[i].multiFlights[0].agencyTotalPrice = currency + totalAmount;
        for (let k = 0; k < this.flightsBindList[i].passengerFares.length; k++) {
          let addedmarkup = (this.filtersBinding.applyMarkup * this.flightsBindList[i].passengerFares[k].count) - (this.previousmarkup * this.flightsBindList[i].passengerFares[k].count);
          taxAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTaxAmount.split(currency)[1]);
          taxAmount += addedmarkup;
          this.flightsBindList[i].passengerFares[k].agencyTaxAmount = currency + taxAmount;
          totalAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTotalPrice.split(currency)[1]);
          totalAmount += addedmarkup;
          totalAmount = Number(totalAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTotalPrice = currency + totalAmount;
        }
      }
      this.batchSize = 100;
      this.startIndex = 0;
      this.displayedFlights = [];
      this.loadNextFlights();
      this.previousmarkup = this.filtersBinding.applyMarkup;
    }
    else if (this.filtersBinding.applyMarkup > 0) {
      for (let i = 0; i < this.flightsBindList.length; i++) {
        let currency: string = this.flightsBindList[i].passengerFares[0].agencyTotalPrice.substring(0, 3);
        let airSeg: AirSegmentsDetailsNew[] = [];
        airSeg = this.flightsBindList[i].airSegmentsNew;
        let totalPassenger = this.searchObj.child + this.searchObj.adult + this.searchObj.infant;
        let addedmarkup = (this.filtersBinding.applyMarkup * totalPassenger) - (this.previousmarkup * totalPassenger);
        // this.totalMarkupPerPassenger = this.markup ;
        let taxAmount: number;
        taxAmount = Number(this.flightsBindList[i].departureFlight.agencyTaxAmount.substring(3));
        taxAmount += addedmarkup;
        taxAmount = Number(taxAmount.toFixed(2));
        this.flightsBindList[i].departureFlight.totalTaxAmount = currency + taxAmount;
        let totalAmount = Number(this.flightsBindList[i].departureFlight.agencyTotalPrice.split(currency)[1]);
        totalAmount += addedmarkup;
        totalAmount = Number(totalAmount.toFixed(2));
        //totalAmount += taxAmount;
        this.flightsBindList[i].departureFlight.agencyTotalPrice = currency + totalAmount;
        for (let k = 0; k < this.flightsBindList[i].passengerFares.length; k++) {
          let addedmarkup = (this.filtersBinding.applyMarkup * this.flightsBindList[i].passengerFares[k].count) - (this.previousmarkup * this.flightsBindList[i].passengerFares[k].count);
          taxAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTaxAmount.split(currency)[1]);
          taxAmount += addedmarkup;
          taxAmount = Number(taxAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTaxAmount = currency + taxAmount;
          totalAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTotalPrice.split(currency)[1]);
          totalAmount += addedmarkup;
          totalAmount = Number(totalAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTotalPrice = currency + totalAmount;
        }
      }
      this.batchSize = 100;
      this.startIndex = 0;
      this.displayedFlights = [];
      this.loadNextFlights();
      this.previousmarkup = this.filtersBinding.applyMarkup;
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Filters Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/



  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Group Ticket Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  GetGroupTicketResult = (): void => {
    this.flightService.GetAgencyAndUserGroupTicketRigts(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data) => {
      this.flightSearchRightsObj = data;
      if (this.flightSearchRightsObj.agencyGroupTicketSearch == true && this.flightSearchRightsObj.userGroupTicketSearch == true) {
        this.getFlightResultService.GetGroupFlightResult(this.searchObj).subscribe((data) => {

          if (data.flights != null) {
            if (data.flights.length > 0) {

              this.flighResultObj.flights = this.flighResultObj.flights.concat(data.flights);
              this.flightsBindList = this.flightsBindList.concat(data.flights);
              this.loadInitialFilters();

              for (let j = 0; j < this.flightsBindList.length; j++) {
                this.popoverArray.push(false);
              }

            }
          }

          this.flightLoaderClose();
          if (data.flights != null) {
            if (data.flights.length > 0) {
              //let response = this.ProcessDatesGroupFlight(data.flights);
              //this.flighResultObj.flights.push(...response);

            }
          }
        });
      }
    });
  }


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Group Ticket END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Change RBD  END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/

  SelectRBDSector(index: number) {
    this.flightsBeforeLoad = true;
    let params = new ChangeRBDParamsGalileo();
    params.flightSearch = this.searchObj;
    let spCode = this.displayedFlights[index].airSegmentsNew;
    params.supplier = this.displayedFlights[index].departureFlight.supplier;
    params.bookingPCC = this.displayedFlights[index].departureFlight.pcc;
    params.flightScheduleNew = this.displayedFlights[index];
    params.supplierpricingSolution = this.displayedFlights[index].supplierPricingSolution;

    this.flightService.InitialBook(params).subscribe((data) => {
      this.flightsBeforeLoad = false;
      if (data.flights.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'These selected RBDs are not bookable.' });

      }
      if (data.flights.length > 0) {
        this.flightsBeforeLoad = false;
        // document.querySelector(".rbd-book").classList.remove("rbd-hide");
        this.rbdflightData = data;
        let rbdCharges = [];
        let penaltyC = [];
        this.grossTotal = 0;
        let baggage = [];

        if (this.rbdflightData.flights[0].departureFlight.supplier != "mm") {

          for (let n = 0; n < this.rbdflightData.flights.length; n++) {
            for (let m = 0; m < this.rbdflightData.flights[n].frontBaggageAllowance.length; m++) {
              baggage[m] = {
                sector: this.rbdflightData.flights[n].frontBaggageAllowance[m].sector ? this.rbdflightData.flights[n].frontBaggageAllowance[m].sector :
                  this.rbdflightData.flights[n].airSegmentsNew[m].origin.code + '--' + this.rbdflightData.flights[n].airSegmentsNew[m].destination.code,
                baggageDet: this.rbdflightData.flights[n].frontBaggageAllowance[m].checkinBaggage ? this.rbdflightData.flights[n].frontBaggageAllowance[m].checkinBaggage : "",
                desc2: this.rbdflightData.flights[n].frontBaggageAllowance[m].cabinBaggage ? this.rbdflightData.flights[n].frontBaggageAllowance[m].cabinBaggage : ""
              }
            }
          }
          this.rbdBaggage = baggage;

          for (let p = 0; p < this.rbdflightData.flights.length; p++) {
            for (let q = 0; q < this.rbdflightData.flights[p].passengerFares.length; q++) {
              let paxType: string = "";
              let cancel: string = "";
              let change: string = "";
              // if (this.rbdflightData.flights[p].passengerFares[q].passengerType != null &&
              //   this.rbdflightData.flights[p].passengerFares[q].passengerType != undefined)
              //   this.rbdflightData.flights[p].passengerFares[q].passengerType + "(" + this.rbdflightData.flights[p].passengerFares[q].count + ")";
              // if (this.rbdflightData.flights[p].AirPricingSolution.airPricingInfo[q].cancelPenalty != null &&
              //   this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty != undefined)
              //   cancel = this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty[0].amount ? this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty[0].amount : 0;
              // if (this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty != null &&
              //   this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty != undefined)
              //   change = this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty[0].amount ? this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty[0].amount : 0
              penaltyC[q] = {
                paxType,
                cancel,
                change
              }
              this.penaltyCharge = penaltyC;
            }
          }
          for (let p = 0; p < this.rbdflightData.flights.length; p++) {
            for (let q = 0; q < this.rbdflightData.flights[p].passengerFares.length; q++) {
              rbdCharges[q] = {
                paxType: this.rbdflightData.flights[p].passengerFares[q].passengerType + "(" + this.rbdflightData.flights[p].passengerFares[q].count + ")",
                basePrice: this.rbdflightData.flights[p].passengerFares[q].agencyBaseFareAmount,
                taxes: this.rbdflightData.flights[p].passengerFares[q].agencyTaxAmount,
                serviceCharges: this.rbdflightData.flights[p].passengerFares[q].agencyServiceFee,
                discount: this.rbdflightData.flights[p].passengerFares[q].agencyDiscount,
                total: this.rbdflightData.flights[p].passengerFares[q].agencyTotalPrice,
              }
              this.grossTotal = this.grossTotal + Number(this.rbdflightData.flights[p].passengerFares[q].agencyTotalPrice.slice(3)) *
                this.rbdflightData.flights[p].passengerFares[q].count;
            }
          }
          for (let cd = 0; cd < rbdCharges.length; cd++) {
            if (rbdCharges[cd].paxType.slice(0, 1) == "1") {
              rbdCharges[cd].paxType = "ADT" + rbdCharges[cd].paxType.slice(1);
            }
            if (rbdCharges[cd].paxType.slice(0, 1) == "2") {
              rbdCharges[cd].paxType = "CHD" + rbdCharges[cd].paxType.slice(1);
            }
            if (rbdCharges[cd].paxType.slice(0, 1) == "3") {
              rbdCharges[cd].paxType = "INF" + rbdCharges[cd].paxType.slice(1);
            }
          }
          this.rbdCharg = rbdCharges;
        }
      }
    });
  }

  SelectRbdFlight() {
    try {
      if (this.rbdflightData != null) {
        if (this.rbdflightData.flights.length > 0) {
          let requestObj = new BookingBasicProperties();
          requestObj.extraProfit = this.filtersBinding.applyMarkup;
          requestObj.brandsSelected = false;
          requestObj.fromAirport = this.rbdflightData.flights[0].fromAirport;
          requestObj.toAirport = this.rbdflightData.flights[0].toAirport;
          requestObj.airportsList = this.airportList;
          requestObj.bookingPCC = this.rbdflightData.flights[0].departureFlight.pcc;
          requestObj.airSegment = this.rbdflightData.flights[0].airSegmentsNew;
          requestObj.flightProp = this.searchObj;
          requestObj.stopcount = this.rbdflightData.flights[0].departureFlight.stopCount;
          requestObj.supplierCode = this.rbdflightData.flights[0].departureFlight.supplier;
          requestObj.passengerFares = this.rbdflightData.flights[0].passengerFares;
          requestObj.nonRefundable = this.rbdflightData.flights[0].departureFlight.nonRefundable;
          requestObj.supplierPricingSolution = this.rbdflightData.flights[0].supplierPricingSolution;
          requestObj.transactionIdentifierJ = this.rbdflightData.flights[0].transactionIdentifier;
          requestObj.flightscheduleNew = this.rbdflightData.flights[0];
          localStorage.setItem('bkdata', JSON.stringify(requestObj));
          this.router.navigateByUrl('/passengerInfo');
        }
        else {


        }
      }
    }
    catch (e) {
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Change RBD END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
}
